import { Guid } from "@ioip/core/lib";
import { ActionType } from "./ActionType";
import { IUpdateEntityItemsAction } from "./IUpdateEntityItemsAction";
import { IIncludeDocumentAction } from "./IIncludeDocumentAction";

export interface IAction {
    id: string;
    type: ActionType;
    order: number;
    disabled: boolean;
    updateEntityItems?: IUpdateEntityItemsAction;
    includeDocument?: IIncludeDocumentAction;
}

export const defaultIAction = (): IAction => ({
    id: Guid.newGuid().toString(),
    type: ActionType.undefined,
    order: 0,
    disabled: false
});
